export default __webpack_public_path__ + "static/media/search_zoom.eeca5340.svg";